export default __webpack_public_path__ + "static/media/link-oblique.a0a291bb.svg";